export const lensAddresses = {
  accountLens: "0x66EefD479DD08B7f8B447A703bf76C4b96C42A42",
  eulerEarnVaultLens: "0x782A21Ab6eEa4919Fd2F1B6e94c2BE3349A71233",
  irmLens: "0x2E79A4A15EEAd542cFe663d081D108D9cfff6D6C",
  oracleLens: "0xb65A755dBE9C493dcC3EEC3aaDeb211888C1a8C5",
  utilsLens: "0xB3EC37ebA3Ea95cb4A6A34883485b9e8fC3b67C6",
  vaultLens: "0x0eaDDE9EfCf1540dcA8f94e813E12db55f8405a8",
} as const
